import { Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { AppConfig } from './app-config.model';
import { APP_VERSION } from './app-version';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ConfigService {
  private readonly configSignal = signal<AppConfig | null>(null);
  
  // Getter público para acesso direto via Signal
  readonly settings = this.configSignal.asReadonly();

  constructor(private http: HttpClient) {}

  async loadConfig(): Promise<void> {
    try {
      const config = await lastValueFrom(
        this.http.get<Omit<AppConfig, 'version'>>(environment.configFile)
      );
      this.configSignal.set({ ...config, version: APP_VERSION });
      console.info(`[Config] Ambiente "${environment.name}" carregado de ${environment.configFile}`);
    } catch (error) {
      console.error(`Failed to load configuration from ${environment.configFile}`, error);
      throw error; // Bloqueia o bootstrap da app em caso de erro crítico
    }
  }
}